import { createBrowserHistory } from 'history'
import { memo } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FullLoader } from '../Components/LoaderBox/Loader'
import NotFound from './NotFound'

export const history = createBrowserHistory()

const RouteWrapper = FullLoader(() => import('./RouteWrapper'))

const routes = [
  // {
  //   path: '/',
  //   screen: FullLoader(() => import('../Screens/Home/Home'))
  // },
  {
    path: '/',
    screen: FullLoader(() => import('../Screens/Landing/Landing')),
    headerFooter: false
  },
  {
    path: '/login',
    screen: FullLoader(() => import('../Screens/Login/Login')),
    headerFooter: false
  },
  {
    path: '/forgot-username',
    screen: FullLoader(() => import('../Screens/Login/ForgotUsername')),
    headerFooter: false
  },
  {
    path: '/forgot-password',
    screen: FullLoader(() => import('../Screens/Login/ForgotPassword')),
    headerFooter: false
  },

  {
    path: '/profiles',
    screen: FullLoader(() => import('../Screens/StaticScreens/Profiles'))
  },
  {
    path: '/jobs',
    screen: FullLoader(() => import('../Screens/StaticScreens/Jobs'))
  },
  {
    path: '/projects',
    screen: FullLoader(() => import('../Screens/StaticScreens/Projects'))
  },
  {
    path: '/endorsements',
    screen: FullLoader(() => import('../Screens/StaticScreens/Endorsements'))
  },
  {
    path: '/market-place',
    screen: FullLoader(() => import('../Screens/StaticScreens/Marketplace'))
  },
  {
    path: '/cookies-policies',
    screen: FullLoader(() => import('../Screens/StaticScreens/CookiesPolicy'))
  },
  {
    path: '/data-privacy',
    screen: FullLoader(() => import('../Screens/StaticScreens/DataPrivacy'))
  },
  {
    path: '/terms-of-use',
    screen: FullLoader(() => import('../Screens/StaticScreens/TermsOfUse'))
  },
  {
    path: '/legal-disclaimer',
    screen: FullLoader(() => import('../Screens/StaticScreens/LegalDisclaimer'))
  },
  {
    path: '/faqs',
    screen: FullLoader(() => import('../Screens/Faqs/Faqs'))
  },
  {
    path: '/highendconsuting',
    screen: FullLoader(() => import('../Screens/Home/HighEndConsulting')),
    headerFooter: true
  },
  {
    path: '/grcitauditing',
    screen: FullLoader(() => import('../Screens/Home/GRCITAuditing')),
    headerFooter: true
  },
  {
    path: '/webmobileapplications',
    screen: FullLoader(() => import('../Screens/Home/WebMobileApplications')),
    headerFooter: true
  },
  {
    path: '/startupsupport',
    screen: FullLoader(() => import('../Screens/Home/StartupSupport')),
    headerFooter: true
  },
  {
    path: '/brochure',
    screen: FullLoader(() => import('../Screens/Helps/BrochurePdf')),
    headerFooter: false
  },
  {
    path: '/itprojects',
    screen: FullLoader(() => import('../Screens/Home/ITProjects')),
    headerFooter: true
  },
  {
    path: '/itresources',
    screen: FullLoader(() => import('../Screens/Home/ITResources')),
    headerFooter: true
  },
  {
    path: '/itresources2',
    screen: FullLoader(() => import('../Screens/Home/ITResources2')),
    headerFooter: true
  },
  {
    path: '/about-us',
    screen: FullLoader(() => import('../Screens/Home/AboutUs')),
    headerFooter: true
  },
  {
    path: '/our-team',
    screen: FullLoader(() => import('../Screens/Home/OurTeam')),
    headerFooter: true
  },
  {
    path: '/homeNew',
    screen: FullLoader(() => import('../Screens/Home/HomeNew'))
    // headerFooter: false
  },
  {
    path: '/wens-heactor',
    screen: FullLoader(() => import('../Screens/Home/WHeactor')),
    headerFooter: true
  },
  {
    path: '/wens-scalehighs',
    screen: FullLoader(() => import('../Screens/Home/WScaleHighs')),
    headerFooter: true
  },
  {
    path: '/wens-easypraxis',
    screen: FullLoader(() => import('../Screens/Home/WEasyPraxis')),
    headerFooter: true
  },
  {
    path: '/wens-scaledcompliance',
    screen: FullLoader(() => import('../Screens/Home/WScaledCompliance')),
    headerFooter: true
  }
]

function Routes() {
  return (
    <Switch>
      {routes.map(({ path, screen, exact = true, headerFooter = true, footer, metaObj }) => (
        <Route
          key={path}
          exact={exact}
          path={path}
          render={(props) => (
            <RouteWrapper
              {...props}
              headerFooter={headerFooter}
              footer={footer}
              metaObj={metaObj}
              screen={screen}
            />
          )}
        />
      ))}

      <Redirect from="/app" to="/" />
      <Route component={NotFound} />
    </Switch>
  )
}

export default memo(Routes)
